import React, { FunctionComponent, useState, useCallback } from 'react';
import Enquire from '../../../presentational/actionButtons/customiseEnquire/Enquire';
import IActionButtonProps from '../IActionButtonProps';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import { JourneyType } from '../../../../../__generated__/globalTypes';
import useCheckoutRedirectHandler from '../../../../hooks/useCheckoutRedirectHandler';

const ContinueInDealerShipButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const {
    spc: {
      customise: { displayReserveOnline },
    },
  } = useTheme<ISpcTheme>();
  const { checkoutRedirectHandler, basketInitV3Data } = useCheckoutRedirectHandler(
    config,
    JourneyType.continue_in_dealership,
  );
  const buttonIsDisabled = !basketInitV3Data.vehicleId || isSubmitting || config.disabled;
  const isPrimary = !config.isOrderOnlineEnabled && !displayReserveOnline;

  const onClick = useCallback(() => {
    checkoutRedirectHandler(setIsSubmitting);
  }, [checkoutRedirectHandler]);

  return (
    <Enquire onClick={onClick} disabled={buttonIsDisabled} isPrimary={config.isCheckoutLiteEnabled && isPrimary} />
  );
};

export default ContinueInDealerShipButtonContainer;
